import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "./context/AuthContext";
import { Layout } from "./components/Layout";

// Pages
import { Login } from "./pages/Login";
import { Dashboard } from "./pages/Dashboard";
import { Clientes } from "./pages/Clientes";
import { ClienteForm } from "./pages/ClienteForm";
import { Produtos } from "./pages/Produtos";
import { ProdutoForm } from "./pages/ProdutoForm";
import { Receitas } from "./pages/Receitas";
import { ReceitaForm } from "./pages/ReceitaForm";
import { ReceitaView } from "./pages/ReceitaView";
import { Utilizadores } from "./pages/Utilizadores";
import { UtilizadorForm } from "./pages/UtilizadorForm";
import { Definicoes } from "./pages/Definicoes";
import { Recepcao } from "./pages/Recepcao";
import { Mensagens } from "./pages/Mensagens";

// Protected Route Component
const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen bg-slate-50 flex items-center justify-center">
        <div className="h-8 w-8 border-4 border-teal-600 border-t-transparent rounded-full animate-spin"></div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  return <Layout>{children}</Layout>;
};

function AppRoutes() {
  return (
    <Routes>
      {/* Public Routes */}
      <Route path="/login" element={<Login />} />
      <Route path="/recepcao" element={<Recepcao />} />

      {/* Protected Routes */}
      <Route
        path="/"
        element={
          <ProtectedRoute>
            <Dashboard />
          </ProtectedRoute>
        }
      />
      
      {/* Clientes */}
      <Route
        path="/clientes"
        element={
          <ProtectedRoute>
            <Clientes />
          </ProtectedRoute>
        }
      />
      <Route
        path="/clientes/novo"
        element={
          <ProtectedRoute>
            <ClienteForm />
          </ProtectedRoute>
        }
      />
      <Route
        path="/clientes/:id/editar"
        element={
          <ProtectedRoute>
            <ClienteForm />
          </ProtectedRoute>
        }
      />

      {/* Produtos */}
      <Route
        path="/produtos"
        element={
          <ProtectedRoute>
            <Produtos />
          </ProtectedRoute>
        }
      />
      <Route
        path="/produtos/novo"
        element={
          <ProtectedRoute>
            <ProdutoForm />
          </ProtectedRoute>
        }
      />
      <Route
        path="/produtos/:id/editar"
        element={
          <ProtectedRoute>
            <ProdutoForm />
          </ProtectedRoute>
        }
      />

      {/* Receitas */}
      <Route
        path="/receitas"
        element={
          <ProtectedRoute>
            <Receitas />
          </ProtectedRoute>
        }
      />
      <Route
        path="/receitas/nova"
        element={
          <ProtectedRoute>
            <ReceitaForm />
          </ProtectedRoute>
        }
      />
      <Route
        path="/receitas/:id"
        element={
          <ProtectedRoute>
            <ReceitaView />
          </ProtectedRoute>
        }
      />
      <Route
        path="/receitas/:id/editar"
        element={
          <ProtectedRoute>
            <ReceitaForm />
          </ProtectedRoute>
        }
      />

      {/* Utilizadores */}
      <Route
        path="/utilizadores"
        element={
          <ProtectedRoute>
            <Utilizadores />
          </ProtectedRoute>
        }
      />
      <Route
        path="/utilizadores/novo"
        element={
          <ProtectedRoute>
            <UtilizadorForm />
          </ProtectedRoute>
        }
      />
      <Route
        path="/utilizadores/:id/editar"
        element={
          <ProtectedRoute>
            <UtilizadorForm />
          </ProtectedRoute>
        }
      />

      {/* Definicoes */}
      <Route
        path="/definicoes"
        element={
          <ProtectedRoute>
            <Definicoes />
          </ProtectedRoute>
        }
      />

      {/* Mensagens */}
      <Route
        path="/mensagens"
        element={
          <ProtectedRoute>
            <Mensagens />
          </ProtectedRoute>
        }
      />

      {/* Catch all - redirect to dashboard */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <AppRoutes />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
